import React from "react";

import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { TiArrowMinimise } from "react-icons/ti";
import "./MySkillPart.css";
import skillIcons1 from "../assets/icons/atom.png";
import skillIcons2 from "../assets/icons/nextjs_icon_213852.png";
import skillIcons3 from "../assets/icons/node.png";
import skillIcons4 from "../assets/icons/vagueness.png";
import skillIcons5 from "../assets/icons/storage-box.png";

import personalskill1 from "../assets/icons/punctual.png";
import personalskill2 from "../assets/icons/responsible.png";
import personalskill3 from "../assets/icons/idea.png";
import personalskill4 from "../assets/icons/confidence.png";
import personalskill5 from "../assets/icons/friendship.png";
import personalskill6 from "../assets/icons/arrow.png";
import { motion } from "framer-motion";
import hackerImage from "../assets/hacker.png";
import Skill from "../components/Skill/Skill";
import skillList from "../utiliti/SkillList";

const percentage = 66;
const MySkills = () => {
  return (
    <div id="resume" className="py-24">
      <div className=" MyContainer after:absolute after:content-['Skills']  after:tracking-widest after:text-own-gray-black after:text-[6rem] relative  sm:after:text-[8rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] after:-top-[120px] after:-z-10 items-center mx-auto  ">
        <div>
          <div className="flex flex-col justify-center w-full items-center">
            <div className="text-center">
              <h4 className="text-[2.3rem] text-[#38D9A9] font-semibold">
                Skills
              </h4>
              <p className="text-[1.3rem]">My technical level</p>
            </div>
          </div>
          <div className="grid grid-cols-2 w-[900px] mx-auto gap-[60px] mt-[60px]">
            <div className=" bg-own-primary p-6  border-2 border-own-border-color border-opacity-10 bg-opacity-20 text-center">
              <h3 className="text-[22px] mb-5">Frontend developer</h3>
              <div className="grid grid-cols-2  ">
                <div className="flex flex-col  items-center justify-center">
                  <div className="">
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      HTML
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      CSS
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Javascript
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Bootstrap
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Tailwind css
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Matrial Ui
                    </span>
                  </div>
                </div>
                <div className="flex flex-col  items-center justify-center">
                  <div>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      React Js
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Next Js
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Redux
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Typescript
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Firebase
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Framer Motion
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className=" bg-own-primary p-6  border-2 border-own-border-color border-opacity-10 bg-opacity-20 text-center rounded-md">
              <h3 className="text-[22px] mb-5">Backend developer</h3>
              <div className="grid grid-cols-2  ">
                <div className="flex flex-col  items-center justify-center">
                  <div className="">
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Javascript
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Node Js
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Express Js
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      MongoDB
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Rest API
                    </span>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Stripe Js
                    </span>
                  </div>
                </div>
                <div className="flex flex-col  items-center ">
                  <div>
                    <span className="flex items-center mb-3">
                      <i className="ri-arrow-right-s-line"></i>
                      Mongoose
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySkills;
